module.exports = __webpack_public_path__ + "img/1.7b6ce331.png";